import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">&copy; 2020 Around The U.S.</p>
    </footer>
  );
}

export default Footer;
